const KEY = 'instafarm:lastPublishResult';
const TTL_MS = 24 * 60 * 60 * 1000;

export interface PublishResultAccount {
  id?: string;
  name: string;
  profilePicture?: string;
  status: 'success' | 'error';
  friendly?: string;
  raw?: string;
}

export interface PublishResultSnapshot {
  kind: 'reel' | 'post';
  state: 'done' | 'error';
  accounts: PublishResultAccount[];
  successCount: number;
  total: number;
  errorReason?: string;
  ts: number; // caller passes Date.now()
}

export function savePublishResult(snapshot: PublishResultSnapshot): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    // storage full / disabled (private mode) — non-fatal
  }
}

export function loadPublishResult(): PublishResultSnapshot | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PublishResultSnapshot;
    if (!parsed || typeof parsed.ts !== 'number' || Date.now() - parsed.ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    return null;
  }
}

export function clearPublishResult(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
